// import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import * as M from "../../css/components/modal/modalPopup"
import CardButton from '../buttons/cardButton';

function modalConfirm(props) {
    return (
        <Modal
            {...props}
            size="md"  
            // style={{ maxWidth: '360px', width: '80%' }}    
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <M.Modal_Heading_event>
                        {props.title}
                    </M.Modal_Heading_event>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{textAlign: 'center'}}>
                <M.Modal_Para1>
                    {props.text}                   
                </M.Modal_Para1>
                {props.action}              
                <div className='d-flex gap-3 mt-4 mb-3 justify-content-center'>
                    <CardButton 
                        fontSize="15px" 
                        height="40px"
                        width="60px" 
                        bg={props.confirmDisabled ? "#c1c1c1" :  "#FF9C00"}
                        name="확인" 
                        onClick={props.onComfirm} 
                        disabled={props.confirmDisabled}
                    > </CardButton>
                    <CardButton fontSize="15px" height="40px" width="60px" bg="#c1c1c1" name="취소" onClick={props.onCancel}></CardButton>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default modalConfirm;